<template>
    <!-- Odoo 350042: подключение приложения-аутентификатора — QR из otpauth-URI, секрет для ручного ввода, код подтверждения.
         URI несёт секрет: живёт только в props, не уходит ни в store, ни в лог -->
    <div class="mfa-totp-setup">
        <div class="mfa-step-text">{{ t('Scan the QR code with an authenticator app (Google Authenticator, Microsoft Authenticator, 1Password…), then enter the 6-digit code it shows.') }}</div>
        <div class="mfa-qr-wrap">
            <img v-if="qrSrc" :src="qrSrc" class="mfa-qr" :alt="t('QR code for the authenticator app')" />
        </div>
        <div v-if="secret" class="mfa-secret">
            <span class="mfa-muted">{{ t('Cannot scan? Enter this key manually:') }}</span>
            <code class="mfa-secret-code">{{ groupSecret(secret) }}</code>
        </div>
        <label for="mfaTotpSetupCode" class="mfa-label">{{ t('Code from the app') }}</label>
        <InputText id="mfaTotpSetupCode" v-model="code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6"
                   class="w-full mfa-code-input" placeholder="123456" @keyup.enter="confirm" />
        <Button :label="t('Confirm')" :loading="busy" :disabled="busy || code.replace(/\D/g, '').length !== 6" class="w-full mt-3" :class="buttonClass" @click="confirm" />
    </div>
</template>

<script>
import qrcode from 'qrcode-generator'
import { t } from '@/i18n'
import { otpauthSecret, groupSecret, normalizeCode } from '@/utils/mfa'

export default {
    name: 'MfaTotpSetup',
    props: {
        uri: { type: String, default: '' },
        busy: { type: Boolean, default: false },
        buttonClass: { type: String, default: '' },
    },
    emits: ['confirm'],
    data() {
        return { code: '' }
    },
    computed: {
        secret() { return otpauthSecret(this.uri) },
        qrSrc() {
            if (!this.uri) return ''
            try {
                const qr = qrcode(0, 'M')
                qr.addData(this.uri)
                qr.make()
                return qr.createDataURL(5, 2)
            } catch (e) {
                return ''
            }
        },
    },
    methods: {
        t,
        groupSecret,
        confirm() {
            const c = normalizeCode(this.code, 'totp')
            if (c.length !== 6 || this.busy) return
            this.$emit('confirm', c)
        },
    },
}
</script>

<style scoped>
.mfa-totp-setup { display: flex; flex-direction: column; }
.mfa-qr-wrap { display: flex; justify-content: center; margin: 1rem 0; }
.mfa-qr { width: 200px; height: 200px; image-rendering: pixelated; background: #fff; padding: 6px; border-radius: 6px; }
.mfa-secret { display: flex; flex-direction: column; gap: 0.25rem; margin-bottom: 1rem; }
.mfa-secret-code { font-size: 15px; letter-spacing: 1px; color: inherit; background: none; word-break: break-all; user-select: all; }
.mfa-muted { color: #86868b; font-size: 14px; }
.mfa-label { display: block; color: #86868b; font-size: 15px; margin-bottom: 0.5rem; }
.mfa-step-text { color: #86868b; font-size: 15px; }
.mfa-code-input { padding: 1rem; font-size: 20px; letter-spacing: 4px; text-align: center; }
</style>
